import { CHAIN_ID } from 'src/constants/config';
import { Networks } from 'src/types/networks';

export const isPussyChain = CHAIN_ID === Networks.SPACE_PUSSY;
